<template>
  <div id="app">
    <router-view></router-view>
    <!--<isLogin v-if="state"></isLogin>-->
    <!--<noLogin v-else></noLogin>-->
  </div>
</template>

<script>
//  import isLogin from './basicParts/isLogin.vue';
//  import noLogin from './basicParts/noLogin.vue';
import queryString from "query-string";
export default {
  name: "app",
  data() {
    return {};
  },
  created() {
    const params = queryString.parse(location.href.split("?")[1]);

    if (params.sync === "1" && params.token) {
      this.sync_auth(params);
    } else if (params.token) {
      this.sso_auth(params);
    }
  },
  methods: {
    async sync_auth(params) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });
      try {
        localStorage.setItem("language", params.language || "zh-CN");
        localStorage.setItem("token", params.token);
        const res = await this.$http.get(`/main/syncAccount`);

        if (res.data.state == 1) {
          let areaType = "全国";
          if (res.data.area) {
            areaType = res.data.area;
          } else if (res.data.city) {
            areaType = res.data.city;
          } else if (res.data.province) {
            areaType = res.data.province;
          }
          this.setCookie("name", res.data["用户名"], 1);
          this.setCookie("level", res.data["用户权限"] || 0, 1);
          this.setCookie("username", this.username + "app", 1);
          this.setCookie("password", this.password, 1);
          this.setCookie("childAcc", res.data["子账号"], 1);
          window.localStorage.setItem("areaType", areaType);
          window.localStorage.setItem("token", res.data.token);
          window.localStorage.setItem("loginName", this.username);
          window.localStorage.setItem("menu", res.data["菜单栏"]);
          window.localStorage.setItem("key", res.data["功能按键"]);
          window.localStorage.setItem("userInfo", JSON.stringify(res.data));
          window.sessionStorage.setItem("embed", params.embed || "0");
          if (res.data.company) {
            window.localStorage.setItem("company", res.data.company);
          } else {
            window.localStorage.removeItem("company");
          }
          if (this.getCookie("level") == 103) {
            this.$router.push({ path: "/main/detectPoints" });
          } else if (this.getCookie("level") == 104) {
            this.$router.push({ path: "/main/auditor" });
          } else if (this.getCookie("level") <= 5) {
            this.$router.push({ name: "region" });
          } else {
            this.$router.push({ name: "realTime" });
          }

          if (params.redirect) {
            this.$router.push({ path: params.redirect });
          } else {
            location.href =
              location.origin + location.pathname + "#" + this.$route.path;
          }
        } else {
          this.$router.replace({ name: "login" });
        }
      } finally {
        loading.close();
      }
    },
    async sso_auth(params) {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });
      try {
        const res = await this.$http.get(
          `/main/ssoLogin?token=${params.token}`
        );

        if (res.data.state == 1) {
          let areaType = "全国";
          if (res.data.area) {
            areaType = res.data.area;
          } else if (res.data.city) {
            areaType = res.data.city;
          } else if (res.data.province) {
            areaType = res.data.province;
          }

          this.setCookie("name", res.data["用户名"], 1);
          this.setCookie("level", res.data["用户权限"] || 0, 1);
          this.setCookie("username", this.username + "app", 1);
          this.setCookie("password", this.password, 1);
          this.setCookie("childAcc", res.data["子账号"], 1);
          window.localStorage.setItem("username", res.data["用户名"]);
          window.localStorage.setItem("areaType", areaType);
          window.localStorage.setItem("token", res.data.token);
          window.localStorage.setItem("loginName", this.username);
          window.localStorage.setItem("menu", res.data["菜单栏"]);
          window.localStorage.setItem("key", res.data["功能按键"]);
          window.localStorage.setItem("userInfo", JSON.stringify(res.data));
          if (res.data.company) {
            window.localStorage.setItem("company", res.data.company);
          } else {
            window.localStorage.removeItem("company");
          }

          this.$store.commit("SET_OSS", true);

          this.$router.replace(
            typeof params.redirect === "string" ? params.redirect : "/"
          );
        } else {
          // user.reset();
          this.$router.replace({ name: "login" });
        }
      } finally {
        loading.close();
      }
    },
  },
};
</script>
<style>
@import "assets/css/commonStyle.less";
@import "assets/css/iconfont.css";
@import "assets/menuicon/iconfont.css";
@import "assets/css/iconfont(jin).css";
</style>



// WEBPACK FOOTER //
// App.vue?c0fc251e